// extracted by mini-css-extract-plugin
module.exports = {"offer_detail":"offer_detail___-iaSvz_9S2q7Eb2165iWk_","offer_detail__container":"offer_detail__container___-OVE3Py-kt4ARsIK6F2fUV"};